export const COLLISION_GEOM_KIND_KEYS = [
  "plane",
  "hfield",
  "sphere",
  "capsule",
  "ellipsoid",
  "cylinder",
  "box",
  "mesh",
] as const;

export type CollisionGeomKindKey = (typeof COLLISION_GEOM_KIND_KEYS)[number];

/** MJCF / app geom kinds normalized for collision coloring (box includes "rectangle"). */
export function normalizeCollisionGeomKind(raw: string | undefined | null): CollisionGeomKindKey {
  const k = String(raw ?? "").toLowerCase();
  if (k === "plane") return "plane";
  if (k === "hfield") return "hfield";
  if (k === "sphere") return "sphere";
  if (k === "capsule") return "capsule";
  if (k === "ellipsoid") return "ellipsoid";
  if (k === "cylinder") return "cylinder";
  if (k === "box" || k === "rectangle") return "box";
  if (k === "mesh") return "mesh";
  return "box";
}

export const COLLISION_GEOM_KIND_LABELS: Record<CollisionGeomKindKey, string> = {
  plane: "Plane",
  hfield: "Height Field",
  sphere: "Sphere",
  capsule: "Capsule",
  ellipsoid: "Ellipsoid",
  cylinder: "Cylinder",
  box: "Box",
  mesh: "Mesh",
};

export const DEFAULT_COLLISION_GEOM_COLORS_BY_KIND: Record<CollisionGeomKindKey, string> = {
  plane: "#8d6e63",
  hfield: "#6d8f3f",
  sphere: "#8e24aa",
  capsule: "#43a047",
  ellipsoid: "#c0ca33",
  cylinder: "#1e88e5",
  box: "#fb8c00",
  mesh: "#ff2222",
};
